export default __webpack_public_path__ + "e6f78b1bf3e44f75a58e6272cb22f8a9.svg";